import { render } from "./CreateStudent.vue?vue&type=template&id=304a5609&scoped=true"
import script from "./CreateStudent.vue?vue&type=script&lang=js"
export * from "./CreateStudent.vue?vue&type=script&lang=js"

import "./CreateStudent.vue?vue&type=style&index=0&id=304a5609&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\1h_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-304a5609"]])

export default __exports__